import { useParams } from 'react-router-dom';

import FormData from './FormData';

import LayoutContent from '@/layout/Content';

import './style.scss';
const AddFloor = () => {
    const { id } = useParams();
    const title = id ? 'CẬP NHẬT' : 'THÊM MỚI';
    return (
        <LayoutContent className="p-add-floor" title={`TẦNG / ${title}`} isBack>
            <div className="p-add-floor__form">
                <FormData />
            </div>
        </LayoutContent>
    );
};

export default AddFloor;
